import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { usePolicyTypeId } from '../../../../../../../../../../services/policy-service';
import RequirementTemplateBlueprintType from '../../../../../../../../../../types/RequirementTemplateBlueprintType';
import LoadingSpinner from '../../../../../../../../../Spinner';
import TrayHeader from '../../../../../../../../../Tray/TrayHeader';

import SetPolicyFieldValuesForm from './SetPolicyFieldValuesForm';

const SetPolicyFieldValuesTray = ({ blueprint, currentPolicyTypeId }) => {
  const dispatch = useDispatch();
  const currentPolicyType = useSelector(blueprint.selectCurrentPolicyType);
  const { data, isLoading } = usePolicyTypeId(currentPolicyTypeId);

  useEffect(() => {
    if (data && !currentPolicyType) {
      dispatch(blueprint.setCurrentPolicyType(data));
    }
  }, [currentPolicyType, isLoading, data]);

  if (!currentPolicyType && isLoading) return <LoadingSpinner />;

  const title = currentPolicyType && currentPolicyType.displayName;

  const renderContent = () => <SetPolicyFieldValuesForm blueprint={blueprint} />;

  return (
    <>
      <TrayHeader title={title} />
      {renderContent()}
    </>
  );
};

SetPolicyFieldValuesTray.propTypes = { blueprint: RequirementTemplateBlueprintType, currentPolicyTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) };

export default SetPolicyFieldValuesTray;
